<template>
  <div class="mask" v-if="showChangeModal">
    <div class="form-section message-modal">
      <h2 class="curr-step-title">{{ i18n.t('update-modal-change-membership-button') }}</h2>
      <div class="curr-step-desc">
        <span class="step-desc">{{ i18n.t('change-modal-desc') }}</span>
      </div>
      <div class="content">
        <ul>
          <li
            class="membership-info-wrapper"
            :class="{ selected: index === currentIndex }"
            v-for="(card, index) in cardList"
            :key="index"
            @click="handleSelect(card, index)"
          >
            <div class="membership-info">
              <div class="card-logo">
                <img
                  v-if="card.bankLogoThumbNails"
                  :src="card.bankLogoThumbNails"
                  alt="bank logo"
                />
                <div class="card-status">
                  <div class="card-in-use-tag" v-if="card.isSelected === 1">
                    {{ i18n.t('mbs-switch-card-use') }}
                  </div>
                  <img :src="index === currentIndex ? Selected : NotSelected" alt="select icon" />
                </div>
              </div>
              <p class="membership-no">{{ formatCardNo(card.dragonCode) }}</p>
              <div class="membership-others-info">
                <div>
                  <span v-if="card.status === 9"
                    ><span>{{ i18n.t('entitlement-refresh') }}</span>
                    <span>: </span>
                    <span>{{ card.cardValidDate }}</span></span
                  >
                  <span v-else class="invalid-card">{{ i18n.t(getCardStatus(card)) }}</span>
                </div>
                <div>
                  <span>{{ card.issueName }}</span>
                  <span>, </span>
                  <span>{{ card.cardType }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="divider"></div> -->
          </li>
        </ul>
      </div>
      <div class="btn-wrapper">
        <button class="dpi-button" @click="handleBack">{{ i18n.t('cancel') }}</button>
        <button class="dpi-button dpi-button-primary" @click="handleSave">
          {{ i18n.t('btn-confirm') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import Selected from '@/assets/images/icon-selected-dark.svg';
  import NotSelected from '@/assets/images/icon-not-selected-dark.svg';
  // 解决获取不到$t的问题
  import i18n from '@/i18n/index';
  import store from '@/store';
  // 解决获取不到$router的问题
  import router from '@/router';
  import { formatCardNo } from '@/utils/index';
  import http from '@/services';
  import mdModal from '@/components/BaseUi/MessageModal/src';

  export default {
    name: 'ChangeMembership',

    data() {
      return {
        i18n,
        showChangeModal: false,
        useNowCardIndex: 0,
        cardList: [],
        currentIndex: 0,
        currentCard: {},
        cardUseTitle: '',
        Selected,
        NotSelected,
      };
    },

    watch: {
      // 监听路由变化
      $route() {
        if (this.showChangeModal) {
          // 如果弹窗显示中，隐藏弹窗
          this.handleBack();
        }
      },
    },

    mounted() {
      // this.getAccountList();
    },
    methods: {
      formatCardNo,
      wrapperBrandTag(str) {
        /* eslint-disable*/
        function abc(match, p1) {
          return `<sup>${p1.slice(1, p1.length - 1)}</sup>`;
        }

        return str?.replace(/(\{[^\{\}]+\})/g, abc).replaceAll('®', '<sup>®</sup>');
      },

      handleBack() {
        this.showChangeModal = false;
      },
      getBankLogo() {
        const { userId } = store.state.userInfo;
        http.account.getBankLogo({ userId }).then(res => {
          store.commit('setHeaderBankLogo', res.data.topLogo);
        });
      },

      async handleSave() {
        const { userId, sessionId } = store.state.userInfo;
        if (this.currentIndex === this.useNowCardIndex) {
          return;
        }
        const { dragonCode, visaCardType, agentId } = this.currentCard;
        const validData = {
          userId,
          sessionId,
          dragonCode,
          version: '1.0.0',
          lang: localStorage.getItem('lang'),
          // deviceId: JSON.parse(localStorage.getItem('currentDeviceName')),
          deviceId: localStorage.getItem('deviceId'),
        };
        const data = {
          dragonCode,
          userId,
          sessionId,
        };
        const validRes = await http.member.creditCardValid(validData);
        // 校验通过，成功切卡 (目前ingenicoType和vcesCheckResult是不会同时需要校验的)
        if (validRes.payload.ingenicoType === 2 && validRes.payload.vcesCheckResult === 0) {
          await http.member.setDefaultCard(data).then(res => {
            if (res?.state === '11') {
              sessionStorage.setItem('visaCardType', visaCardType);
              store.commit('setState', {
                state: 'visaCardType',
                values: visaCardType,
              });
              store.commit('setState', {
                state: 'userInfo',
                values: {
                  ...store.state.userInfo,
                  agentId,
                },
              });
              // 弹窗提示成功
              mdModal.show({
                image: false,
                closeIcon: false,
                title: 'mbs-switch-success-title',
                desc: 'change-modal-success',
                confirmBtn: 'ok',
                justHide: true,
                i18nNeed: true,
                successCallback: () => {
                  store.commit('setState', {
                    state: 'isLogin',
                    values: true,
                  });
                  sessionStorage.setItem('isLogin', true);
                  store.commit('setState', {
                    state: 'isIngenicoUpdatePending',
                    values: false,
                  });
                  router.push('/account/membership');
                },
              });
            } else {
              mdModal.show({
                image: false,
                closeIcon: false,
                title: 'update-modal-fail',
                desc: res?.note,
                confirmBtn: 'ok',
                justHide: true,
                i18nNeed: false,
              });
              console.error(res.note);
            }
          });
        } else {
          // 需要更新卡
          mdModal.show({
            image: false,
            closeIcon: false,
            title: 'update-modal-fail',
            desc: 'change-modal-fail-desc',
            confirmBtn: 'ok',
            justHide: true,
            i18nNeed: true,
          });
        }
      },

      handleSelect(card, index) {
        this.currentIndex = index;
        this.currentCard = card;
        console.log('card', card);
      },

      getCardStatus(data) {
        const { status } = data;
        if (status === 8) return 'mbs-switch-card-suspended';
        if (status === 7) return 'mbs-switch-card-expired';
        return null;
      },

      // TODO: 两处在用，可以抽离到vuex中 获取membership页面数据
      getAccountList(switchSuccess = false) {
        const { userId, sessionId } = store.state.userInfo;
        const data = {
          userId,
          device: 'web',
          version: '1.0.0',
          lang: i18n.locale,
          sessionId,
        };
        http.member.getAccountList(data).then(
          res => {
            if (res.state === '11') {
              this.cardList = res.payload;
              // 设置当前默认被选中的项
              const selectIndex = res.payload.findIndex(item => item.isSelected === 1);
              this.currentIndex = selectIndex;
              this.useNowCardIndex = selectIndex;

              // 切换成功后跳转会membership页面
              if (switchSuccess) {
                router.push({ name: 'Membership', query: { switchSuccess: true } });
              }
            } else {
              console.error(res);
            }
          },
          err => {
            console.error(err);
          },
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './changeModal.scss';
  @import './changeModalMobile.scss';
</style>
